// libs
import React, { memo } from 'react';
import isEmpty from 'lodash/isEmpty';

// styles
import { Tag } from './styles';

// defs
interface IProductTag {
  productTag: string;
}

function ProductTag({ productTag }: IProductTag) {
  if (isEmpty(productTag)) {
    return null;
  }

  return <Tag data-test="product-tag">{productTag}</Tag>;
}

export default memo(ProductTag);
